import { render, staticRenderFns } from "./SharingTab.vue?vue&type=template&id=59d829c2&scoped=true&"
import script from "./SharingTab.vue?vue&type=script&lang=js&"
export * from "./SharingTab.vue?vue&type=script&lang=js&"
import style0 from "./SharingTab.vue?vue&type=style&index=0&id=59d829c2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d829c2",
  null
  
)

export default component.exports